import { render } from "./AddInsurancePage.vue?vue&type=template&id=9a1486b2&scoped=true"
import script from "./AddInsurancePage.vue?vue&type=script&lang=js"
export * from "./AddInsurancePage.vue?vue&type=script&lang=js"

import "./AddInsurancePage.vue?vue&type=style&index=0&id=9a1486b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1486b2"]])

export default __exports__